import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  useUser,
} from 'auth/index';
import { signInPathReturningTo } from 'src/routes/signInRedirect';

type ProtectedPageProps = {
  children: React.ReactNode;
};

/**
 * If user is signed in, renders the main page with sidebar
 * If user is not, redirects to sign in page, which brings them back to this page once they sign in.
 *
 * @returns
 */
export const ProtectedPage: FC<ProtectedPageProps> = ({ children }) => {
  const { isSignedIn, isLoaded } = useUser();
  const { pathname, search } = useLocation();
  if (!isLoaded) {
    return null;
  }
  if (isSignedIn) {
    return children;
  }
  return (<Navigate to={signInPathReturningTo(pathname + search)} replace />);
};
